import { render, staticRenderFns } from "./trace.vue?vue&type=template&id=27955664&scoped=true"
import script from "./trace.vue?vue&type=script&lang=js"
export * from "./trace.vue?vue&type=script&lang=js"
import style0 from "./trace.vue?vue&type=style&index=0&id=27955664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27955664",
  null
  
)

export default component.exports